var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { RadixToast, RadixToastProvider } from "../primitives/RadixToast";
import { useUI } from "../../providers";
export var GlobalToast = function () {
    var _a = useUI(), toasts = _a.toasts, setToasts = _a.setToasts;
    if (!toasts.length) {
        return null;
    }
    return (React.createElement(RadixToastProvider, null, toasts.map(function (toast) {
        var _a, _b;
        return (React.createElement(RadixToast, { key: toast.id, open: toast.open, message: toast.message, variant: toast.variant, mustAcknowledge: toast.mustAcknowledge, actionLabel: (_a = toast.action) === null || _a === void 0 ? void 0 : _a.label, onAction: (_b = toast.action) === null || _b === void 0 ? void 0 : _b.onClick, onOpenChange: function (open) {
                setToasts(function (previous) {
                    if (!open) {
                        return previous.filter(function (candidate) { return candidate.id !== toast.id; });
                    }
                    return previous.map(function (candidate) {
                        if (candidate.id !== toast.id) {
                            return candidate;
                        }
                        return __assign(__assign({}, candidate), { open: open });
                    });
                });
            } }));
    })));
};
